(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Sqids", [], factory);
	else if(typeof exports === 'object')
		exports["Sqids"] = factory();
	else
		root["Sqids"] = factory();
})(self, () => {
return 